import { render, staticRenderFns } from "./PortalNav.vue?vue&type=template&id=d1dc2466&"
import script from "./PortalNav.vue?vue&type=script&lang=js&"
export * from "./PortalNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports